import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import infoIconBlack from "assets/icons/info-icon-outline-black.svg";
import infoIconGrey from "assets/icons/info-icon-outline-grey.svg";
import infoIconWhite from "assets/icons/info-icon-outline-white.svg";
import styles from "../style.module.scss";

interface TableToolTipProps {
  iconColor?: "black" | "grey" | "white";
  title: string;
  altText: string;
}

export const TableToolTip = ({ iconColor = "black", title, altText }: TableToolTipProps) => {
  const { t } = useTranslation();
  let icon = infoIconBlack;

  switch (iconColor) {
    case "white":
      icon = infoIconWhite;
      break;
    case "grey":
      icon = infoIconGrey;
      break;
    default:
      icon = infoIconBlack;
      break;
  }

  return (
    <Tooltip title={t(title)} zIndex={100000} trigger={["hover", "focus"]}>
      <img src={icon} alt={t(altText) || ""} tabIndex={0} className={styles.icon} />
    </Tooltip>
  );
};
